<template>
  <div class="product">
    <div class="li" v-for="(item, index) in productList" :key="index">
      <a class="item a-link" @click="toProductDetail(item)">
        <div class="itemImgBox">
          <div class="imgBox">
            <!-- <el-image :src="item.image" fit="cover"></el-image> -->
            <img
              :src="item.image"
              v-show="item.image"
              :alt="item.productName"
            />
          </div>
        </div>
        <div class="text">
          <h4 class="h4" v-if="item.shopType">
            <span class="xhnTextLogo" style="margin-top: -1px">自营</span>
            {{ item.productName }}
          </h4>
          <h4 class="h4" v-else>{{ item.productName }}</h4>
          <!-- <h4 class="h4">
            <span class="xhnTextLogo">自营</span>
            {{ item.productName }}
          </h4>-->
          <div class="priceBox" style="margin-left: 0">
            <span>
              <small style="margin-right: 4px">¥</small>
              {{ item.price }}
            </span>
            <span class="shopName" @click.stop="goStore(item)"
              ><i class="icon-dianputoubu"></i
              ><span>{{ item.shopName }}</span></span
            >
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
export default {
  mixins: [listSearchMixin],
  props: ["productList"],
  data() {
    return {
      shopId: "",
    };
  },
  mounted() {
    this.shopId = parseInt(this.$route.query.shopId);
    console.log(this.shopId);
    // this.getShopType();
  },
  methods: {
    // 跳转去店铺页
    goStore(row) {
      if(sessionStorage.getItem("curentPage4")){
        sessionStorage.removeItem("curentPage4");
      }
      let query = {
        shopId: row.shopId,
      };
      this.$router.push({
        path: "/store",
        query,
      });
    },
    toProductDetail(item) {
      let data = {
        productId: item.productId,
        skuId: item.skuId,
        shopId: item.shopId,
      };
      if (item.classifyType == 1) {
          this.$router.push({
          path: "/productDetail_serv",
          query: {
            proData: JSON.stringify(data),
          },
        });
      } else {
          this.$router.push({
          path: "/productDetail",
          query: {
            proData: JSON.stringify(data),
          },
        });
      }
      
    },
    //获取店铺类型
    getShopType() {
      let self = this;
      let params = {
        url: api.getShopIndex + `?shopId`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          console.log("12345");
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 跳转到店铺
    toStore(id) {
      this.$router.push({
        path: "/store",
        query: {
          shopId: id,
        },
      });
    },
  },
};
</script>
<style lang = "scss" scoped>
.li {
  height: 390px;
  width: 300px;
  margin: 0 10px 20px 0;

  .item {
    display: flex;
    height: 100%;
    width: 100%;
    cursor: pointer;
    flex-direction: column;
    background-color: #ffffff;
    position: relative;
    transition: all 0.2s;
    top: 0;
    left: 0;
    border-radius: 8px;
    &:hover {
      box-shadow: 0px 0px 12px 1px rgba(186, 186, 186, 0.5);
      top: -2px;
      left: 0px;
    }
    .itemImgBox {
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-top: 29px;
      .imgBox {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        height: 257px;
        width: 257px;
        margin: 0 auto;
        border-radius: 8px;
        img {
          height: 100%;
        }
        .el-image {
          width: 257px;
          height: 257px;
          overflow: hidden;
          border-radius: 8px;
        }
      }
    }
    .text {
      padding: 19px 25px 0px 25px;
      text-align: left;
      // height: 180px;
      .h4 {
        height: 44px;
        font-size: 14px;
        text-align: left;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .p {
        color: #999;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 18px;
        position: relative;
        margin-top: 8px;
        &:after {
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -80px;
          width: 160px;
          height: 2px;
          background: #f0f0f0;
          content: "";
        }
      }
      .priceBox {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        // justify-content: flex-start;
        // align-items: flex-start;
        // flex-direction: column;
        padding-top: 6px;
        span {
          height: 26px;
          font-size: 20px;
          font-weight: bold;
          color: #ff4747;
        }
        span.discount {
          font-size: 16px;
          color: #666666;
          text-decoration: line-through;
        }
        span.shopName {
          width: 140px;
          text-align: right;
          height: 30px;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: right;
          // justify-content: flex-start;
          padding-top: 5px;
          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            align-items: center;

            font-size: 14px;
            color: #666666;
            font-weight: normal;
            
          }

          i {
            color: #f77b0b;
            &:before {
              font-size: 22px;
            }
          }
        }
      }
    }
  }
}
.product {
  /* width: 100%;
  display: flex;
  flex-flow: wrap; */

  margin-bottom: 30px;
  width: 1612px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: wrap;
  flex-flow: wrap;
  margin-bottom: 30px;
  background: #fff;
  padding: 10px 0 10px 35px;
  border-radius: 8px;
  /* justify-content: space-between; */

  /* .productBox:nth-of-type(4n){
    margin-right: 0;
  } */
  /* .productBox:hover{
    box-shadow:0 0 20px #cccccc;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/base/productList.vue